import { useState, useEffect } from "react";
import {
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import MapIcon from "@mui/icons-material/Map";
import MapModal from "./MapModal";

const SendLocation = ({ formData, handleChange, highlighted }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [locationMethod, setLocationMethod] = useState("search");
  const [openMapDialog, setOpenMapDialog] = useState(false);
  const [address, setAddress] = useState("");
  const [location, setLocation] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "error",
    message: "",
  });

  useEffect(() => {
    if (
      formData.firstLine !== "" &&
      formData.province !== "" &&
      formData.postcode !== ""
    ) {
      setLocationMethod("manual");
    }
  }, [formData]);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const success = (position) => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    formData.sendLocation = `Latitude: ${latitude}, Longitude: ${longitude}`;
  };

  const error = () => {
    formData.sendLocation = "";
  };

  const handleSaveDialog = () => {
    if (locationMethod === "manual") {
      if (!formData.firstLine) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Please check First Line",
        });
        return;
      }
      if (!formData.province) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Please check Province",
        });
        return;
      }
      if (!formData.postcode) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Please check Postcode",
        });
        return;
      }

      // After manual input, update the location to display
      formData.sendLocation = `${formData.firstLine}, ${formData.province}, ${formData.postcode}`;
    } else {
      formData.sendLocation = address;
      formData.location = location;
    }

    setSnackbar({
      open: true,
      severity: "success",
      message: "Your location is saved",
    });
    setOpenDialog(false);
  };

  // Open the dialog when the edit icon is clicked
  const handleEditLocation = () => {
    setLocationMethod("search"); // Make sure the dialog shows manual input by default
    setOpenDialog(true);
  };

  const handleShareLocation = () => {
    setOpenMapDialog(true);
  };

  const handleConfirm = (value, location) => {
    setAddress(value);
    setLocation(location);
    setOpenMapDialog(false);
  };
  return (
    <Box sx={{ marginY: "10px" }}>
      {/* Display location or share location button */}
      {!formData.sendLocation ? (
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          startIcon={<MapIcon />}
          onClick={handleOpenDialog}
          sx={{ marginTop: "10px" }}
        >
          Share Location
        </Button>
      ) : (
        <div
          style={{
            marginTop: "10px",
            color: "#333",
            display: "flex",
            alignItems: "center",
            marginLeft: "5px",
            border: highlighted ? "2px solid #1976d2" : "none",
          }}
        >
          <span>{formData.sendLocation}</span>
          <IconButton
            sx={{ marginLeft: "10px" }}
            onClick={handleEditLocation} // Open the dialog to edit the location
            color="primary"
          >
            <MyLocationIcon />
          </IconButton>
        </div>
      )}

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Share Location</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">Select location method</FormLabel>
            <RadioGroup
              row
              name="locationMethod"
              value={locationMethod}
              onChange={(e) => setLocationMethod(e.target.value)}
            >
              <FormControlLabel
                value="search"
                control={<Radio />}
                label="Share your location"
              />
              <FormControlLabel
                value="manual"
                control={<Radio />}
                label="Enter manually"
              />
            </RadioGroup>
            {locationMethod === "search" && (
              <>
                <Button
                  color="primary"
                  onClick={handleShareLocation}
                  sx={{ marginTop: "10px", fontSize: "small" }}
                >
                  Share Your Location&nbsp;
                  <MyLocationIcon />
                </Button>
                {address && <Typography variant="body2">{address}</Typography>}
              </>
            )}
          </FormControl>

          {/* IconButton to trigger location sharing */}
          {locationMethod !== "search" && (
            <>
              <TextField
                fullWidth
                margin="dense"
                name="firstLine"
                label="First Line"
                value={formData.firstLine || ""}
                onChange={handleChange}
                required
              />
              <TextField
                fullWidth
                margin="dense"
                name="secondLine"
                label="Second Line"
                value={formData.secondLine || ""}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                margin="dense"
                name="province"
                label="Province"
                value={formData.province || ""}
                onChange={handleChange}
                required
              />
              <TextField
                fullWidth
                margin="dense"
                name="postcode"
                label="Postcode"
                value={formData.postcode || ""}
                onChange={handleChange}
                required
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSaveDialog} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <MapModal
        open={openMapDialog}
        onClose={() => setOpenMapDialog(false)}
        handleConfirm={handleConfirm}
      />
      {/* Snackbar for notifications */}
      {/* <SnackbarAlert
        open={snackbar.open}
        onClose={handleCloseSnackbar}
        severity={snackbar.severity}
        message={snackbar.message}
      /> */}
    </Box>
  );
};

export default SendLocation;
